class SponsorAvatar extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	render() {
		var dims = { maxWidth: this.props.maxWidth, maxHeight: this.props.maxHeight };
		var src = require("owls/default-owl-6.png");
		return (
			<img src={ src } alt="sponsorAvatar" style={ dims } />
		)
	}
};

SponsorAvatar.propTypes = StrictPropTypes({
	// We don't actually use user but we may at some point
	// so we should require it be passed
	sponsor: PropTypes.object.isRequired,

	maxWidth: PropTypes.number,
	maxHeight: PropTypes.number
});

module.exports = SponsorAvatar;


// WEBPACK FOOTER //
// ./modules/components/avatars/SponsorAvatar.js